import styled from 'styled-components';

export const Cell = styled.td`
  padding: 8px;
  font-size: 14px;
`;
